import {
  usePageEvent,
  useRedirectExperimentEvent,
  useUserProperties,
} from 'fitify-ui-onboarding/src/hooks/useEvents'
import type { AppProps } from 'next/app'

import { PagesSideEffects } from 'components/App/PagesSideEffects'
import { ALL_PAGES_MAP } from 'data/routes'
import { useStepNavigation } from 'hooks/useStepNavigation'
import { useUserAnalytics } from 'hooks/useUserAnalytics'

import { useDataState } from '../../utils/state'

export type PlanAppProps = Pick<AppProps, 'Component' | 'pageProps'>

export function PlanApp({ Component, pageProps }: PlanAppProps) {
  const { data } = useDataState()
  const { funnelData } = useStepNavigation({ data })

  // Logs page events
  useUserAnalytics(data, funnelData)
  useUserProperties(funnelData)
  usePageEvent(ALL_PAGES_MAP)
  useRedirectExperimentEvent()

  return (
    <>
      <PagesSideEffects />
      <Component {...pageProps} />
    </>
  )
}
